export default function fixSidescrollerNextAndPrev() {

    var sidescrollers = document.querySelectorAll('.cc-sidescroller-n-text-image .init-sidescroller, .cc-sidescroller-text-n-text-image .init-sidescroller'),
        i;

        for (i = 0; i < sidescrollers.length; ++i) {

            var prevButtons = sidescrollers[i].querySelectorAll('.slick-prev.cc-slick-arrow-big'),
                nextButtons = sidescrollers[i].querySelectorAll('.slick-next.cc-slick-arrow-big'),
                that = sidescrollers[i],
                x;

            for (x = 0; x < prevButtons.length; ++x) {
                prevButtons[x].addEventListener('click', function (e) {
                    $(that).slick('slickPrev');
                });
            }

            for (x = 0; x < nextButtons.length; ++x) {
                nextButtons[x].addEventListener('click', function (e) {
                    $(that).slick('slickNext');
                });
            }
    }
}



//////////////////
// WEBPACK FOOTER
// ./js/2020/_fix-sidescroller_next-and-prev.js
// module id = 3
// module chunks = 0